export const TEST_ID = 'primaryParamsSliders';
